import React from 'react';

/**
 * Raffaello's name-tag — used to sign the manifesto, blog articles, the
 * bottle-section quote and the diary modal.
 *
 * Renamed from the previous hand-drawn SVG signature: the vigneron asked
 * for his printed name in a typewriter face instead of a calligraphic mark.
 * The component export/name is kept for backward-compat with existing
 * callers ({@link ./LempoleSite}, {@link ./DiarioModal}, {@link ./BlogPost},
 * {@link ./VigneronPage}).
 */
export const SignatureSVG = ({ className = '', style = {}, name = 'Raffaello Tiezzi', ...rest }) => (
  <div
    className={`signature-typed ${className}`}
    role="text"
    aria-label={name}
    style={style}
    {...rest}
  >
    <span className="signature-typed__dash" aria-hidden="true">—</span>
    <span className="signature-typed__name">{name}</span>
  </div>
);

export default SignatureSVG;
